export default "__VITE_ASSET__cb72f52e__"